export const resizeHandleMixin = {
  data() {
    return {
      isResizing: false,
      currentResizeId: null,
      startX: 0,
      startWidth: 0
    }
  },

  methods: {
    startResize(event, entId) {
      this.isResizing = true;
      this.currentResizeId = entId;
      this.startX = event.clientX;
      this.startWidth = this.entsWidth[entId];
      
      // Add event listeners
      document.addEventListener('mousemove', this.handleResize);
      document.addEventListener('mouseup', this.stopResize);
    },
    
    handleResize(event) {
      if (!this.isResizing) return;
      
      // For RTL, we invert the diff calculation
      const diff = this.startX - event.clientX;
      const newWidth = Math.max(150, this.startWidth + diff); // Minimum width of 150px
      
      this.entsWidth[this.currentResizeId] = newWidth;
    },
    
    stopResize() {
      this.isResizing = false;
      this.currentResizeId = null;
      
      // Remove event listeners
      document.removeEventListener('mousemove', this.handleResize);
      document.removeEventListener('mouseup', this.stopResize);
    }
  },

  beforeUnmount() {
    // Clean up resize event listeners
    document.removeEventListener('mousemove', this.handleResize);
    document.removeEventListener('mouseup', this.stopResize);
  }
} 